// import map from "@/assets/images/user/map.jpg";
import ComingSoon from "@/components/user/common/ComingSoon";
// import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";
// import ImgZoomPop from "@/components/user/popup/ImgZoomPop";

export default function Map() {
    return (
        <div className="max-w-[1400px] w-full mx-auto px-[20px] xl:px-0">
            <TitleBox title="FESTIVAL MAP" text="행사장 구성" />
            <div className="p-[28px_0_120px] md:p-[48px_0_160px]">
                <ComingSoon />
                {/* <div className="flex flex-col gap-[12px] pb-[20px] md:pb-[28px] xl:flex-row xl:justify-between xl:items-center xl:pb-[40px]">
                    <SubTitle title="전체 공간 구성" />
                    <p className="font-['GongGothicLight'] text-[12px] text-black md:text-[18px]">
                        * 프로그램 위치 및 내용은 변경될 수 있으며, 추후 세부 배치도가 공개됩니다.
                    </p>
                </div>
                <div className="relative overflow-hidden rounded-[20px_0_20px_0] border-2 border-transparent bg-origin-border shadow-[8px_8px_0_0_#D456A0] bg-gradient-to-br from-[#E64C88] to-[#3734C3] md:rounded-[60px_0_60px_0] md:border-4 md:shadow-[16px_16px_0_0_#7C65DB]">
                    <ImgZoomPop img={map} />
                </div> */}
            </div>
        </div>
    );
}
